<template>
  <v-card
    width="300"
    v-show="value"
  >
    <slot name="title">
      <v-card-title class="text-center title font-weight-light" v-if="title">
        {{ title }}
      </v-card-title>
    </slot>

    <pull-to-refresh
      :disabled="!value || !pullToRefresh"
      @refresh="$emit('refresh')"
    >
      <template v-if="loading">
        <v-skeleton-loader
          v-for="i in 3"
          :key="i"
          class="mx-auto"
          max-width="300"
          type="list-item-two-line"
        >
        </v-skeleton-loader>
      </template>

      <template v-else v-for="(item, i) in items">

        <!-- custom list item slot -->
        <slot name="item" v-bind="{
          item,
          idx: i,
          on: { click: () => $emit('click:item', item) }
        }">
          <v-divider :key="`${i}-divider`" />

          <v-list-item
            two-line
            :key="item.id || `item-${i}`"
            @click.stop="$emit('click:item', item)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.summary">
                {{ item.summary }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </slot>

      </template>
    </pull-to-refresh>

    <v-card-actions v-if="viewMoreLink && !loading">
      <slot name="view-more" v-bind="{
        on: { click: () => $emit('click:more') }
      }">
        <v-btn
          block
          outlined
          color="primary"
          prepend-icon="mdi-plus"
          @click.stop="$emit('click:more')"
        >
          {{ $t('components.cardpopup.viewMore') }}
        </v-btn>
      </slot>
    </v-card-actions>

    <slot name="default" />
  </v-card>
</template>

<script>
import PullToRefresh from '@/components/PullToRefresh.vue';

export default {
  components: { PullToRefresh },
  props: {
    value: {
      type: Boolean,
      default: () => true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    title: String,
    items: {
      type: Array,
      default: () => ([]),
    },
    viewMoreLink: {
      type: Boolean,
      default: () => true,
    },
    pullToRefresh: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
